import { endPointFlagIcon } from '../icons/end-point-flag';
import { itemMarkerIcon } from '../icons/item-marker-icon';
import { startPointFlagIcon } from '../icons/start-point-flag';
import { successItemMarkerIcon } from '../icons/success-item-marker-icon';
import { successItemMarkerIconDisabled } from '../icons/success-item-marker-icon-disabled';


//----- START POINT MARKER --------------------------------------------------------------------------------------------------------------------------------------------
const START_POINT_FLAG_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(27, 42),
    anchor: new google.maps.Point(13, 21)
};

export const START_POINT_FLAG = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: startPointFlagIcon,
        ...START_POINT_FLAG_SIZE_DEFAULTS,
        ...overrides
    },
    zIndex: 2
});

//----- END POINT MARKERS --------------------------------------------------------------------------------------------------------------------------------------------
const END_POINT_SYMBOL_DEFAULTS = {
    scale: 20,
    fillColor: '#FFFFFF',
    fillOpacity: 1,
    strokeColor: '#0072CE',
    strokeWeight: 2,
};

const END_POINT_FLAG_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(45, 45),
    anchor: new google.maps.Point(12, 13)
};

export const END_POINT_CIRCLE = (overrides = {}): google.maps.MarkerOptions => ({
  icon: {
    path: google.maps.SymbolPath.CIRCLE,
    ...END_POINT_SYMBOL_DEFAULTS,
    ...overrides
  },
  zIndex: 2
});

export const END_POINT_FLAG = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: endPointFlagIcon,
        ...END_POINT_FLAG_SIZE_DEFAULTS,
        ...overrides
    },
    zIndex: 3
});

//----- ITEM POINT MARKERS --------------------------------------------------------------------------------------------------------------------------------------------
const ITEM_CIRCLE_EFAULTS = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 10,
    fillColor: '#FFFFFF',
    fillOpacity: 1,
    strokeColor: '#0072CE',
    strokeWeight: 4,
};

const ITEM_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(45, 63),
    anchor: new google.maps.Point(27, 42)

};

const ITEM_SUCCESS_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(35, 50),
    anchor: new google.maps.Point(18, 55)
};

export const ITEM_DEFAULT = (index, overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: itemMarkerIcon(index),
        ...ITEM_SIZE_DEFAULTS,
        ...overrides
    },
    zIndex: 2,
    // animation: google.maps.Animation.DROP
});

export const ITEM_SUCCESS = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: successItemMarkerIcon,
        ...ITEM_SUCCESS_SIZE_DEFAULTS,
        ...overrides
    },
    // animation: google.maps.Animation.DROP,
    zIndex: 2
});

export const ITEM_SUCCESS_DISABLED = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: successItemMarkerIconDisabled,
        ...ITEM_SUCCESS_SIZE_DEFAULTS,
        ...overrides
    },
    // animation: google.maps.Animation.DROP,
    zIndex: 2
});

export const ITEM_CIRCLE = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...ITEM_CIRCLE_EFAULTS,
        ...overrides
    },
    zIndex: 1
});

//----- PROYECTED POINT MARKERS --------------------------------------------------------------------------------------------------------------------------------------------
const PROYECTED_CIRCLE_DEFAULTS = {
    scale: 20,
    fillColor: '#eff3f8',
    fillOpacity: 1,
    strokeWeight: 1.75,
    strokeColor: '#0072CE',
    
};

const PROYETED_ARROW_DEFAULTS = {
    scale: 6,
    fillColor: '#0072CE',
    fillOpacity: 1,
    strokeWeight: 0.75,
    strokeColor: '#FFFFFF',
    rotation: 0,
    anchor: new google.maps.Point(0, 2.5)
};

export const PROYECTED_CIRCLE = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...PROYECTED_CIRCLE_DEFAULTS,
        ...overrides
    },
    zIndex: 9000001
});

export const PROYETED_ARROW = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        ...PROYETED_ARROW_DEFAULTS,
        ...overrides
    },
    zIndex: 9000002
});
